<template>
  <div class="basic_wrap">
    <!-- <div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('user.myInvestment')}}</div>
		</div> -->
    <div id="app3">
      <div
        ref="scross"
        class="scross"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="list"
        >
          <div class="val">
            <div class="lef">
              <img
                src="../images/shop2/user.png"
                alt=""
              >
            </div>
            <div class="rig">
              <div class="nav">
                Congratulations ****7840
              </div>
              <div class="navVal">
                Withdrawal $936 Receipt
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";

	import Fetch from "../../utils/fetch";
	Vue.use(Empty);

	export default {
		name: "Order",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				list: [
					'https://img.mexalink.shop/static/img/1.png', 
					'Item 2', 
					'Item 3', 
					'Item 4', 
					'Item 5', 
					'Item 6', 
					'Item 7', 
					'Item 8', 
					'Item 9', 
					'Item 11', 
					'Item 12'
				], // ��ʼ���������б�
				len: 0,
				intervalId: null,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
		    this.startAnimation();
		},
		beforeDestroy() {
			clearInterval(this.intervalId); // ��������ǰ������ʱ��
		},
		methods: {
			startAnimation() {
			  this.intervalId = setInterval(() => {
				// ������������
				const scrossElement = this.$refs.scross;
				scrossElement.style.transition = 'top 2s';
				scrossElement.style.top = this.len * -92 + 'px';
				
				// �������������п�¡��׷��
				setTimeout(() => {
				  this.len++;
				  const randomIndex = Math.floor(Math.random() * this.list.length);
				  const newItem = this.list[randomIndex];
				  this.list.push(newItem); // ��������
				}, 2000);
			  }, 2000);
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 156px;
		background: #3775f4;
		background-size: 100% 100%;
		position: fixed;
		z-index: 15;
	}

	#app3 {
	  width: 100%;
	  height: 520px;
	  overflow: hidden;
	  position: relative;
	}
	
	.scross {
	  position: relative;
	  top: 0;
	}
	
	.list {
	  height: 92px;
	  line-height: 92px;
	  text-align: center;
	  background-color: #f1f1f1;
	  margin-bottom: 0;
	}
	.list,.val{
	    display: flex;
	    align-items: center; 
	    border-bottom: 1px solid #f5f5f5;
	    padding:0 10px;
	    width: 100%;
	}
	.list>.val>.lef{
	    margin-right:8px;
	    display: inline-block;
	    width: 50px;
	    height: 50px;
	    overflow: hidden;
	}
	.list>.val>.lef>img{
	    display: inline-block;
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	    /*background: red;*/
	
	
	}
	.list>.val>.rig>.nav{
	   font-size: 14px;
	   font-weight: bold;
	   margin-bottom: 6px;
	}
	.list>.val>.rig>.navVal{
	    font-size: 12px;
		text-align: left;
	    margin-bottom: 6px;
	 }
	 .list .rig{
		 line-height: 20px;
	 }
</style>
